export default __webpack_public_path__ + "static/media/category.b8ae0c7f.svg";